import React from "react";
import { createSlice } from "@reduxjs/toolkit";

const commonObj = { dob: "", gender: "" };
const initialState = {
  adultData: [],
  childData: [],
  type:""
};

export const InsuredReducer = createSlice({
  name: "common",
  initialState,
  reducers: {
    InitialState: () => initialState,
    onMinusButtonCall: (state, action) => {
    },
    onPlusButtonCall: (state, action) => {
      console.log(state);
    },

    typeOfCalculator:(state,action) => {
     state.type = action.payload
    }
  },
});

// Action creators are generated for each case reducer function
export const { InitialState, onMinusButtonCall, onPlusButtonCall,typeOfCalculator } =
  InsuredReducer.actions;

export default InsuredReducer.reducer;
